import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ReasonVoidListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (acronym?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const reasons = Object.freeze([
  {
    id: 'E',
    value: 'Emesso',
  },
  {
    id: 'N',
    value: 'Non Emesso',
  },
]);

const ReasonVoidListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Giustificativo',
  id = 'reason-void-list',
}: ReasonVoidListComponentProps): React.ReactElement => {
  const list = (reasons as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReasonVoidListComponent.displayName = 'ReasonVoid List component';

const ReasonVoidList = memo(ReasonVoidListComponent);

export default ReasonVoidList as typeof ReasonVoidListComponent;
